const EVENTS = ['input', 'keydown', 'keyup', 'mousedown', 'mouseup', 'select', 'contextmenu', 'drop', 'focusout'];
const PATTERNS = {
    onlyNumbers: (value) => /^-?\d*$/.test(value),
    alphanumeric: (value) => /^([a-zA-Z0-9 _-]+)$/.test(value),
    greaterToZero: (value) => /^(0*[1-9][0-9]*(\.[0-9]+)?|0+\.[0-9]*[1-9][0-9]*)?$/.test(value),
    positiveIntegers: (value) => /^(\d+)?$/.test(value),
    decimalNumber: (value) => /^(\d{1,3}\.?)*$/.test(value),
};
const VALIDATIONS = '';

export { EVENTS as E, PATTERNS as P, VALIDATIONS as V };
